export const POD_FACTS = [
  { key: 'xcode', label: 'Latest Xcode', value: '27.1, plus 26.4' },
  { key: 'sims', label: 'Simulators', value: '4 devices, already booted' },
  { key: 'queue', label: 'Build queue', value: '2 xcodebuild slots' },
  { key: 'agents', label: 'Agents per Pod', value: '2 to 3 active' },
  { key: 'network', label: 'Network', value: 'Outbound only, no SSH' },
  { key: 'stop', label: 'When it stops', value: '10 min after the last session' },
] as const;
